<template>
    <div class="stars_div">
        <TitleBackground></TitleBackground>
        <StarsInfos></StarsInfos>
    </div>
</template>
<script type="text/javascript">
import TitleBackground from './sub_components/title.vue'
import StarsInfos from './sub_components/stars_infos.vue'

export default {
    components: {
        TitleBackground,
        StarsInfos
    }
}

</script>
<style type="text/css" scoped>
.stars_div{
    margin-bottom: 50px;
}
</style>
